import { createSlice } from "@reduxjs/toolkit";
import { getPharmacyDashboardMetrics } from "../../reducer/pharmacyDashboardMetrics/pharmacyDashboardMetricsReducer";

import i18n from "../../i18n";
const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const pharmacyDashboardMetricsSlice = createSlice({
  name: "pharmacyDashboardMetrics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPharmacyDashboardMetrics.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPharmacyDashboardMetrics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || null;
        console.log("✅ Pharmacy Dashboard Metrics Loaded:", action.payload);
      })
      .addCase(getPharmacyDashboardMetrics.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || i18n.t("pharmacy.toast.failedToLoadPharmacyDashboardMetrics");
      });
  },
});

export default pharmacyDashboardMetricsSlice.reducer;
